export default {
  init() {
    // JavaScript to be fired on the home page

    // get variables
    var anable_cookies_node = document.querySelectorAll('.anable-cookies');
    
    if (anable_cookies_node.length > 0) {
      anable_cookies_node.forEach(function (node) {
        node.addEventListener('click', function () {
          // 1. set cookie
          let dataCookiesname = node.getAttribute('data-cookies')
          document.cookie = `${dataCookiesname}=true`;
          // 2. reloadpage
          location.hash = '#to-configurator';
          location.reload();
        });
      });
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateAdnordElementor.js